import type { z } from "zod";
import type { AiIdentification_Schema, AiIdentificationSummary_Schema } from "@/services/aiIdentification/aiIdentificationSchema";

export const KnownErrorCodes = {
  // Vision extraction
  VisionRateLimited: "VISION_RATE_LIMITED",
  VisionTimeout: "VISION_TIMEOUT",
  VisionApiError: "VISION_API_ERROR",
  VisionNoCardDetected: "VISION_NO_CARD_DETECTED",
  VisionMultipleCards: "VISION_MULTIPLE_CARDS",
  VisionNotPokemon: "VISION_NOT_POKEMON",
  VisionNotCard: "VISION_NOT_CARD",
  VisionUnsupportedLanguage: "VISION_UNSUPPORTED_LANGUAGE",
  VisionCardCropped: "VISION_CARD_CROPPED",

  // Database search
  SearchRateLimited: "SEARCH_RATE_LIMITED",
  SearchTimeout: "SEARCH_TIMEOUT",
  SearchApiError: "SEARCH_API_ERROR",
  SearchNotFound: "SEARCH_NOT_FOUND",
  SearchNoConfidentMatch: "SEARCH_NO_CONFIDENT_MATCH",

  // Description generation
  DescRateLimited: "DESC_RATE_LIMITED",
  DescTimeout: "DESC_TIMEOUT",
  DescApiError: "DESC_API_ERROR",

  // Global
  PipelineTimeout: "PIPELINE_TIMEOUT",
} as const;

export type KnownErrorCode = (typeof KnownErrorCodes)[keyof typeof KnownErrorCodes];
export type ErrorCode = KnownErrorCode | (string & {});

export type ErrorResponse = {
  type: ErrorCode;
  message: string;
};

export type AiIdentification = z.infer<typeof AiIdentification_Schema>;

export type AiIdentificationSummary = z.infer<typeof AiIdentificationSummary_Schema>;
